module.exports = __webpack_public_path__ + "img/megamillions_ad1.932827e1.png";